import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page52() {
  useEffect(() => {
    document.title = "Маяк — Страница 51"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page50" />
        <ForwardLink href="/page52" />
      </div>

      <p style={{ textAlign: "right" }}>51.</p>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ТРОПИНКА – ПОЗЖЕ</p>
      <p>ДВОЕ идут сквозь шторм.</p>
      <br/>
      <p>ВНУТРИ. ЖИЛЫЕ ПОМЕЩЕНИЯ. КАМБУЗ – ПОЗЖЕ</p>
      <p>СТАРИК закрывает дверь. МОЛОДОЙ отряхивается от дождя.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Сырость добралась до продуктов.<br/>
        Соленая треска пропала.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Пропала?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Стухла. Начала гнить.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Слава Богу.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Теперь ты меня слышишь?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Слышу что?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что нам нужно экономить.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Экономить?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Опять неповиновение--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Прошел всего один день.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Дьявольский хвост!
      </p>
      <p>МОЛОДОЙ не может понять ход мыслей СТАРИКА.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Слушайте, может быть, тендер, может быть он<br/>
        пришел. Мы пропустили его, вот и все. Я<br/>
        могу спустить дори (спасательную лодку)--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Недели, Уинслоу.
      </p>
      <p style={{ textAlign: "right" }}>51.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page50" />
        <ForwardLink href="/page52" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710628603/the-lighthouse-script/lmthttexboit35x1annz.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page52;
